/** Reads the one-time link from the fragment, which never reaches a server log. */
export function readInloglink(hash: string) {
  const parameters = new URLSearchParams(hash.replace(/^#/, ""));
  const nonce = parameters.get("n");
  const token = parameters.get("t");
  return nonce && token ? { nonce, token } : null;
}

/** True once installed to a home screen: iOS Safari's own flag, or the standard media query elsewhere. */
export function isInstalledPwa() {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (navigator as { standalone?: boolean }).standalone === true
  );
}
